import { useAuth } from '@invara-dev/react-base';
import { useGetCompanyLogoModelQuery } from 'src/features/companyProfileManagement/api/useGetCompanyLogoModel';
import { useObtBreakpointValue } from 'src/hooks/useObtBreakpointValue';

export const CompanyLogoNavLoader = () => {
  const showDesktopView = useObtBreakpointValue({ base: false, sm: false, md: true, lg: true, xlTo2xl: true });

  const auth = useAuth();

  const getCompanyLogoModelQuery = useGetCompanyLogoModelQuery(auth.isAuthenticated);

  if (!auth.isAuthenticated) {
    return <></>;
  }

  return (
    <>
      {getCompanyLogoModelQuery.isFetched &&
        getCompanyLogoModelQuery.data &&
        getCompanyLogoModelQuery.data.LogoBase64 && (
          <img
            src={getCompanyLogoModelQuery.data.LogoBase64}
            alt='Company Logo'
            style={{ maxHeight: showDesktopView ? '60px' : '40px', height: 'auto', width: 'auto' }}
          />
        )}
    </>
  );
};
